// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"220":"3c1ed5d2","731":"673803dc","870":"b80828e2","909":"cc69dbba"}[chunkId] + ".chunk.js";
};